export default class MarkerArrow {
  constructor(width = 36, height = 36) {
    this.width = width
    this.height = height
  }

  getSvg(fillColor = 'red', degree = 0) {
    const svg =
      "<svg width='" +
      this.width +
      "' height='" +
      this.height +
      "' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' version='1.1'>" +
      "<polygon fill='" +
      fillColor +
      "' stroke='#666' stroke-width='1' points='20,90 50,10 80,90 50,70' transform='rotate(" +
      degree +
      " 50 50)'/></svg>"
    return svg
  }

  getSvgImgSrc(fillColor = 'red', degree = 0) {
    const svg = this.getSvg(fillColor)
    return 'data:image/svg+xml;base64,' + btoa(svg)
  }
  getSvgBackground(fillColor = 'red', degree = 0) {
    return 'url(' + this.getSvgImgSrc() + ')'
  }
}
